import Cookies from 'js-cookie';

function setCookie(name: string, value: string, expireTime: number) {
  const date = new Date();
  const time = date.getTime() + expireTime * 1000;
  // date.setTime(date.getTime() + expireTime * 1000);
  // document.cookie =
  //   name + '=' + value + 'expires=' + date.toUTCString() + ';path=/;';
  Cookies.set(name, value, {
    path: '/',
    domain: window.location.hostname,
    expires: new Date(time),
    sameSite: 'None',
    secure: true,
  });
}

function getCookie(name: string) {
  // const value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  // return value ? value[2] : null;
  return Cookies.get(name);
}

function deleteCookie(name: string) {
  // const date = new Date();
  // document.cookie =
  //   name + '= ' + '; expires=' + date.toUTCString() + '; path=/';
  Cookies.remove(name, { path: '', sameSite: 'None', secure: true });
}

function deleteAllCookies() {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }
}
const cookieUtil = {
  setCookie,
  getCookie,
  deleteCookie,
  deleteAllCookies,
};

export default cookieUtil;
